<!--@created ana.castro 2019.08.19 SABO-1056-->
<!--https://developers.facebook.com/docs/facebook-login/permissions-->
<template>
    <div class="fb-login-button" data-width="" data-size="large" data-button-type="continue_with"
         data-auto-logout-link="false" data-use-continue-as="true" data-onlogin="onSocialSignInSuccess"
         data-scope="public_profile,email,user_birthday"></div>
</template>


<script>
    import {getErrorMessage} from '../../_helpers';

    export default {
        name: 'FBLoginButton',

        mounted() {
            // @modified ana.castro 2019.08.16 SABO-1056
            window.fbAsyncInit = function () {
                // eslint-disable-next-line
                FB.init({
                    appId: '508778609888128',
                    autoLogAppEvents: true,
                    cookie: true,  // enable cookies to allow the server to access the session
                    xfbml: true,  // parse social plugins on this page
                    version: 'v4.0' // use graph api version 2.8
                });
            };
            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

            //A única forma que consegui para indicar o que fazer a seguir à resposta de login no FB.
            // Isto é chamado no data-onlogin
            window.onSocialSignInSuccess = this.onSocialSignInSuccess;
        },
        methods: {
            onSocialSignInSuccess(response) {
                this.$log.debug("Social Sign | FACEBOOK | onSocialSignInSuccess");
                this.$log.debug("Social Sign | FACEBOOK | response ", response);
                if (response.authResponse) {
                    //Defining the Login Provider
                    let provider = "FB";

                    //Facebook access_token in the url fragment
                    let code = response.authResponse["accessToken"];

                    const {dispatch} = this.$store;

                    if (provider && code) {
                        this.$log.debug("Social Sign | FACEBOOK | Success");

                        dispatch('authentication/setLoginProvider', {provider, code});

                        dispatch('authentication/loginSocialProvider', {provider, code});
                    } else {
                        this.$log.debug("Social Sign | FACEBOOK | User cancelled login or did not fully authorize");
                        getErrorMessage(undefined, 'Social Sign | FACEBOOK', this);
                    }
                }
            }
        }
    }

</script>

<style scoped>

</style>